import { render, staticRenderFns } from "./TravelDetailTable.vue?vue&type=template&id=374a77cb&"
import script from "./TravelDetailTable.vue?vue&type=script&lang=js&"
export * from "./TravelDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports